/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_WithdrawInputs */

const en_privacy_section_7_withdraw = /** @type {(inputs: Privacy_Section_7_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right to withdraw consent`)
};

const lv_privacy_section_7_withdraw = /** @type {(inputs: Privacy_Section_7_WithdrawInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiesības atsaukt piekrišanu`)
};

/**
* | output |
* | --- |
* | "Right to withdraw consent" |
*
* @param {Privacy_Section_7_WithdrawInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_withdraw = /** @type {((inputs?: Privacy_Section_7_WithdrawInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_WithdrawInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_withdraw(inputs)
	return en_privacy_section_7_withdraw(inputs)
});